var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        _vm.icon ? 'svg-icon' : 'svg-image',
        'svg-' + _vm.glyph,
        _vm.styling
    ]},[_c('svg',{class:[
            !_vm.icon ? 'svg-' + _vm.glyph : '',
            _vm.styling
        ],attrs:{"preserveAspectRatio":"xMinYMin","role":"img"}},[_c('use',{attrs:{"xlink:href":_vm.src}})])])}
var staticRenderFns = []

export { render, staticRenderFns }